import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AbstractControl} from '@angular/forms';
import {Field} from '@app/interfaces';
import {ConfigAPIService} from '@app/services/api/config-api.service';
import {Observable, Subject} from 'rxjs';
import {CurrencyConversionObject} from '@app/services/businessOverview/business-overview-stats.service';
import {AccountConfig} from '@app/interfaces/config/account.config';
import {takeUntil} from "rxjs/operators";

@Component({
    selector: 'app-form-input-percent',
    templateUrl: './form-input-percent.component.html',
    styleUrls: ['./form-input-percent.component.scss'],
    standalone: false
})
export class FormInputPercentComponent implements OnInit, OnDestroy {
  @Input() control: AbstractControl;
  @Input() controls: Array<AbstractControl>;

  @Input() field: Field<string>;
  private connectedFieldValue: any;
  public calculatedValue: number;

  private destroy$: Subject<void> = new Subject<void>();
  private currencyConversion: CurrencyConversionObject;
  accountConfig$: Observable<AccountConfig>;

  constructor(
    private configService: ConfigAPIService
  ) {
  }

  ngOnInit() {
    this.accountConfig$ = this.configService.getAccountConfig().pipe(takeUntil(this.destroy$));

    this.accountConfig$.subscribe(result => {
      this.currencyConversion = result.currencyConversion;
      this.connectedFieldValue = this.getLiveConnectedFieldValue();

      const connectedFieldControl = this.controls[this.field.config.connected_field_uuid];
      connectedFieldControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe(() => {
        this.connectedFieldValue = this.getLiveConnectedFieldValue();
        this.calculateValueFromPercent();
      });
    });

    this.calculateValueFromPercent();
  }

  ngOnDestroy() {
    this.destroy$.next();
  }

  private getLiveConnectedFieldValue(): number {
    const connectedFieldControl = this.controls[this.field.config.connected_field_uuid];
    const rate = this.currencyConversion?.latestRate ?? 1;
    return (connectedFieldControl?.value ?? 0) * rate;
  }

  calculateValueFromPercent() {
    this.calculatedValue = Math.round(this.connectedFieldValue * this.control.value) / 100;
  }

  onPercentFieldChange(event: any) {
    if (this.getLiveConnectedFieldValue() !== 0) {
      this.field.value = Number(event.target.value).toFixed(2);
      this.control.setValue(Number(event.target.value));

      this.calculateValueFromPercent();
    }
  }

  onRawFieldChange(event: any) {
    const liveConnectedFieldValue = this.getLiveConnectedFieldValue();
    if (liveConnectedFieldValue !== 0) {
      const value = ((event.target.value) / liveConnectedFieldValue) * 100;
      this.field.value = Number(value).toFixed(2);
      this.control.setValue(value);
      this.calculateValueFromPercent();
    }
  }
}
